import { render, staticRenderFns } from "./DrawableInfoTop.vue?vue&type=template&id=6b8cea94&scoped=true"
import script from "./DrawableInfoTop.vue?vue&type=script&lang=js"
export * from "./DrawableInfoTop.vue?vue&type=script&lang=js"
import style0 from "./DrawableInfoTop.vue?vue&type=style&index=0&id=6b8cea94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cea94",
  null
  
)

export default component.exports